/* 🤖 this file was generated by svg-to-ts */
export const matIconVolumeMute: {
  name: 'volume-mute';
  data: string;
} = {
  name: 'volume-mute',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z"/></svg>`
};
